import { PropsWithChildren, ReactNode } from 'react';
import './nav-bar.scss';

interface INavbarProps {
  logo?: ReactNode;
  prefixText?: ReactNode;
  assistiveToolbar?: ReactNode;
}

export function Navbar({ 
  children, 
  logo, 
  prefixText, 
  assistiveToolbar 
}: PropsWithChildren<INavbarProps>) {
  return (
    <div className="navbar">
      <div className="navbar-left">
        {logo && <div className="navbar-logo">{logo}</div>}
        {prefixText && <div className="navbar-logo-text">{prefixText}</div>}
        <nav className="navbar-links">
          {children}
        </nav>
      </div>
      <div className="navbar-right">
        {assistiveToolbar ? assistiveToolbar : null}
      </div>
    </div>
  );
}